import RootState from '../../rootState';
import UploadFile, { UploadFileRequest } from '../../../components/shared/FileUpload/UploadFile';

export interface State {
    files: Array<UploadFile>;
    loading: boolean;
    processingAction: boolean; // adding, updating, removing
    savedFiles: boolean; // saving
}

//get state from rootState
export const stateSelectorsUploadFile = {
    getState: (rootState: RootState): State => rootState.entities.attachmentData,

    getFiles(rootState: RootState): Array<UploadFile> {
        const { files } = this.getState(rootState);
        return files;
    },

    loading: (rootState: RootState): boolean => rootState.entities.attachmentData.loading,
    processingAction: (rootState: RootState): boolean => rootState.entities.attachmentData.processingAction, //updating
    getSavedFiles: (rootState: RootState): boolean => rootState.entities.attachmentData.savedFiles, //saving
};

// SAGA
export class SagaAction {
    type: string;

    // registrationId
    sourceId: string;

    // for add/update
    filesRequest: Array<UploadFileRequest>;

    // for remove
    fileId: string;
}
const baseSagaAction = new SagaAction();

export const sagaActionTypes = {
    GET_FILES_BY_SOURCE_ASYNC: 'GET_FILES_BY_SOURCE_ASYNC',
    ADD_NEW_FILES_ASYNC: 'ADD_NEW_FILES_ASYNC',
    UPDATE_FILES_ASYNC: 'UPDATE_FILES_ASYNC',
    REMOVE_FILES_ASYNC: 'REMOVE_FILES_ASYNC',
};

export const sagaActionsUploadFile = {
    getUploadFilesBySourceAsync: (sourceId: string): SagaAction => ({
        ...baseSagaAction,
        type: sagaActionTypes.GET_FILES_BY_SOURCE_ASYNC,
        sourceId
    }),

    addNewFilesAsync: (files: Array<UploadFileRequest>, sourceId: string): SagaAction => ({
        ...baseSagaAction,
        type: sagaActionTypes.ADD_NEW_FILES_ASYNC,
        filesRequest: files,
        sourceId
    }),

    updateFilesAsync: (files: Array<UploadFileRequest>, sourceId: string): SagaAction => ({
        ...baseSagaAction,
        type: sagaActionTypes.UPDATE_FILES_ASYNC,
        filesRequest: files,
        sourceId
    }),

    removeFileAsync: (fileId: string, sourceId: string): SagaAction => ({
        ...baseSagaAction,
        type: sagaActionTypes.REMOVE_FILES_ASYNC,
        fileId: fileId,
        sourceId
    }),
};

// REDUX
export class ReduxAction {
    type: string;

    files: Array<UploadFile>;

    fileId: string;
}
const baseReduxAction = new ReduxAction();

export const reduxActionTypes = {
    GET_FILES_BY_SOURCE_PROCESSING: 'GET_FILES_BY_SOURCE_PROCESSING',
    GET_FILES_BY_SOURCE_SUCCEEDED: 'GET_FILES_BY_SOURCE_SUCCEEDED',
    GET_FILES_BY_SOURCE_FAILED: 'GET_FILES_BY_SOURCE_FAILED',

    ADD_NEW_FILES_PROCESSING: 'ADD_NEW_FILES_PROCESSING',
    ADD_NEW_FILES_SUCCEEDED: 'ADD_NEW_FILES_SUCCEEDED',
    ADD_NEW_FILES_FAILED: 'ADD_NEW_FILES_FAILED',

    UPDATE_FILES_PROCESSING: 'UPDATE_FILES_PROCESSING',
    UPDATE_FILES_SUCCEEDED: 'UPDATE_FILES_SUCCEEDED',
    UPDATE_FILES_FAILED: 'UPDATE_FILES_FAILED',

    REMOVE_FILES_PROCESSING: 'REMOVE_FILES_PROCESSING',
    REMOVE_FILES_SUCCEEDED: 'REMOVE_FILES_SUCCEEDED',
    REMOVE_FILES_FAILED: 'REMOVE_FILES_FAILED',
};

export const reduxActions = {
    // Get files
    getFilesBySourceProcessing: (): ReduxAction => ({
        ...baseReduxAction,
        type: reduxActionTypes.GET_FILES_BY_SOURCE_PROCESSING,
    }),

    getFilesBySourceSucceeded: (files: Array<UploadFile>): ReduxAction => ({
        ...baseReduxAction,
        type: reduxActionTypes.GET_FILES_BY_SOURCE_SUCCEEDED,
        files: files
    }),

    getFilesBySourceFailed: (): ReduxAction => ({
        ...baseReduxAction,
        type: reduxActionTypes.GET_FILES_BY_SOURCE_FAILED,
    }),

    // Add new files
    addNewFilesProcessing: (): ReduxAction => ({
        ...baseReduxAction,
        type: reduxActionTypes.ADD_NEW_FILES_PROCESSING,
    }),

    addNewFilesSucceeded: (files: Array<UploadFile>): ReduxAction => ({
        ...baseReduxAction,
        type: reduxActionTypes.ADD_NEW_FILES_SUCCEEDED,
        files: files
    }),

    addNewFilesFailed: (): ReduxAction => ({
        ...baseReduxAction,
        type: reduxActionTypes.ADD_NEW_FILES_FAILED,
    }),

    // Update files
    updateFilesProcessing: (): ReduxAction => ({
        ...baseReduxAction,
        type: reduxActionTypes.UPDATE_FILES_PROCESSING,
    }),

    updateFilesSucceeded: (files: Array<UploadFile>): ReduxAction => ({
        ...baseReduxAction,
        type: reduxActionTypes.UPDATE_FILES_SUCCEEDED,
        files: files
    }),

    updateFilesFailed: (): ReduxAction => ({
        ...baseReduxAction,
        type: reduxActionTypes.UPDATE_FILES_FAILED,
    }),

    // Remove files
    removeFilesProcessing: (): ReduxAction => ({
        ...baseReduxAction,
        type: reduxActionTypes.REMOVE_FILES_PROCESSING,
    }),

    removeFilesSucceeded: (files: Array<UploadFile>): ReduxAction => ({
        ...baseReduxAction,
        type: reduxActionTypes.REMOVE_FILES_SUCCEEDED,
        files: files
    }),

    removeFilesFailed: (): ReduxAction => ({
        ...baseReduxAction,
        type: reduxActionTypes.REMOVE_FILES_FAILED,
    }),
};


// WEBPACK FOOTER //
// ./src/modules/entities/attachment/index.ts